import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import TextPage from '../TextPage/TextPage';

import { POLICY_LINKS } from '../../constant';
import { FC } from 'react';

const CONTENT_MAP = {
  '/terminal/privacy-policy': 'pageContent_privacyPolicy',
  '/terminal/terms-of-service': 'pageContent_termsOfService',
  '/terminal/public-offer': 'pageContent_publicOffer',
  '/terminal/end-user-license-agreement': 'pageContent_endUserLicenseAgreement',
};
interface InfoPagePolicyProps {
  className?: string;
}
const InfoPagePolicy: FC<InfoPagePolicyProps> = ({ className }) => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <TextPage
      nav={{
        title: t('infoPages_navTitle'),
        items: POLICY_LINKS,
      }}
      className={className}
    >
      {t(CONTENT_MAP[router.pathname])}
    </TextPage>
  );
};

export default InfoPagePolicy;
